module.exports = __webpack_public_path__ + "assets/img/mask-twelve-long.63719ef2.png";